import { useMemo } from "react";
import postingSchemeService, { PostingSchemeDirection } from "api/postingSchemeService";

/**
 * Audyt schematów księgowania: buduje z indeksu BE lookup i zwraca funkcję
 * sprawdzającą, czy dla danego kontrahenta (po NIP lub ContractorId) w danym
 * kierunku (Purchase/Sale) istnieje schemat księgowania. Używane do oznaczania
 * pozycji zielonym badge na liście „Dokumenty księgowe".
 */

export const normNip = (nip?: string | null): string => (nip ?? "").replace(/\D/g, "");

export interface SchemeMatchArgs {
  nip?: string | null;
  contractorId?: string | null;
  direction: PostingSchemeDirection;
}

export const useSchemeMatcher = (): ((args: SchemeMatchArgs) => boolean) => {
  const { data: index = [] } = postingSchemeService.useSchemesIndex();

  return useMemo(() => {
    const byNip = new Set<string>();
    const byCid = new Set<string>();
    for (const e of index) {
      const dir = e.direction === "Sale" ? "Sale" : "Purchase";
      if (e.nip) byNip.add(`${normNip(e.nip)}|${dir}`);
      if (e.contractorId) byCid.add(`${e.contractorId}|${dir}`);
    }
    return ({ nip, contractorId, direction }: SchemeMatchArgs): boolean => {
      const dir = direction === "Sale" ? "Sale" : "Purchase";
      const n = normNip(nip);
      if (n && byNip.has(`${n}|${dir}`)) return true;
      if (contractorId && byCid.has(`${contractorId}|${dir}`)) return true;
      return false;
    };
  }, [index]);
};

export default useSchemeMatcher;
